import { CustomFieldTextSearchType } from './custom-field-filters.i';
var CustomFieldFiltersMapBuilder = /** @class */ (function () {
    function CustomFieldFiltersMapBuilder() {
        this.customFieldFilters = {};
    }
    CustomFieldFiltersMapBuilder.prototype.addFilter = function (fieldName, filter) {
        this.customFieldFilters[fieldName] = filter;
        return this;
    };
    CustomFieldFiltersMapBuilder.prototype.build = function () {
        return this.customFieldFilters;
    };
    return CustomFieldFiltersMapBuilder;
}());
export { CustomFieldFiltersMapBuilder };
var CustomFieldFilterBuilder = /** @class */ (function () {
    function CustomFieldFilterBuilder() {
        this.customFieldFilter = {
            text: '',
            from: 0,
            to: 0,
            values: [],
            bool: false,
            searchType: CustomFieldTextSearchType.CONTAINS
        };
    }
    CustomFieldFilterBuilder.prototype.withFrom = function (from) {
        this.customFieldFilter.from = from;
        return this;
    };
    CustomFieldFilterBuilder.prototype.withTo = function (to) {
        this.customFieldFilter.to = to;
        return this;
    };
    CustomFieldFilterBuilder.prototype.withValues = function (values) {
        this.customFieldFilter.values = values;
        return this;
    };
    CustomFieldFilterBuilder.prototype.withText = function (text) {
        this.customFieldFilter.text = text;
        return this;
    };
    CustomFieldFilterBuilder.prototype.withBool = function (bool) {
        this.customFieldFilter.bool = bool;
        return this;
    };
    CustomFieldFilterBuilder.prototype.withSearchType = function (searchType) {
        this.customFieldFilter.searchType = searchType;
        return this;
    };
    CustomFieldFilterBuilder.prototype.build = function () {
        return this.customFieldFilter;
    };
    return CustomFieldFilterBuilder;
}());
export { CustomFieldFilterBuilder };
//# sourceMappingURL=custom-field-filters.builder.js.map